export enum TimeTrackerType {
  WORK = "Work",
  LUNCH_TIME = "Lunch Time",
  BREAK_TIME = "Break Time",
  TRAVEL = "Travel",
}
